  (function () {
    'use strict';

    /* ---- Die drei Gewinne ----
       `chance` sind Prozent und muessen zusammen 100 ergeben. Die Codes
       muessen in Shopify unter Rabatte existieren - am 21.09.2026 angelegt
       und im Warenkorb gegengeprueft.

       WARUM DER NAPF-CODE EIN KAUF-X-ERHALTE-Y IST:
       Ein produktbezogener Prozent-Rabatt mit Mindestbestellwert griff nie -
       Shopify rechnet den Mindestwert dabei nur gegen die beguenstigte Zeile
       (14,90 EUR), nicht gegen den Warenkorb. Ohne Mindestwert koennte man
       sich die Unterlage allein greifen. Deshalb: Brunnen im Warenkorb ->
       100 % auf 1x Napfunterlage. */
    /* Wert der Unterlage = Vergleichspreis der Variante in Shopify (sonst
       ihr Preis) - frueher fest 29,90 und damit anders als im Warenkorb. */
    var FQRAD_CFG = window.__fqRadCfg || {};
    var NAPF_WERT = FQRAD_CFG.napfWert || 0;
    var GEWINNE = [
      { code: 'NAPFRAD', chance: 98, art: 'artikel', betrag: null,
        kurz: 'Napfunterlage', lang: 'Napfunterlage geschenkt',
        sub: 'Im Wert von ' + NAPF_WERT.toFixed(2).replace('.', ',') + ' € – liegt beim Kauf des Sparpakets gratis dabei.',
        feld: 'Napfunterlage',
        bild: true, bildUrl: FQRAD_CFG.bildNapf || '',
        statt: NAPF_WERT, kennzeichen: 'Glücksrad-Gewinn',
        zeile: { name: 'Glücksrad-Gewinn', sub: 'Napfunterlage geschenkt', rechts: 'gratis' } },
      { code: 'RAD5',  chance: 1, art: 'betrag', betrag: 5,
        kurz: '5 € Gutschein',  lang: '5 € Gutschein',
        sub: 'Wird beim Kauf automatisch abgezogen.',
        feld: 'Gutschein', bildUrl: FQRAD_CFG.bild5 || '' },
      { code: 'RAD10', chance: 1, art: 'betrag', betrag: 10,
        kurz: '10 € Gutschein', lang: '10 € Gutschein',
        sub: 'Wird beim Kauf automatisch abgezogen.',
        feld: 'Gutschein', bildUrl: FQRAD_CFG.bild10 || '' }
    ];

    /* Die acht Felder des Rades. Nur Anzeige - die Chance haengt an GEWINNE.
       Vier Napf-Felder, je zwei fuer die Betraege, abwechselnd angeordnet,
       damit das Rad ausgewogen aussieht. */
    var FELDER = ['NAPFRAD', 'RAD5', 'NAPFRAD', 'RAD10', 'NAPFRAD', 'RAD5', 'NAPFRAD', 'RAD10'];

    var LISTE    = 'YhTqYs';                 /* E-Mail-Liste (Katze), Single Opt-in */
    var COMPANY  = 'WC7MXS';
    /* Gueltigkeit des Gewinns. 1440 = 24 Stunden (Stand 22.09.).
       Vorher 30 Minuten - zu knapp: lief das Fenster ab, waehrend die
       Napfunterlage schon im Warenkorb lag, verschwand der Rabattcode,
       die Zeile blieb aber drin und wurde still berechnet (Bestellung #1289).
       MUSS mit klaviyo-auto-discount.liquid uebereinstimmen. */
    var MINUTEN  = 1440;
    var RUHE_TAGE = 7;
    var SEKUNDEN = 6;
    var SCROLL   = 0.30;

    /* Sammelprofil fuer die Zaehl-Ereignisse. Klaviyo braucht zu jedem
       Ereignis ein Profil; ohne dieses Sammelprofil legte jede Einblendung
       ein neues anonymes an - taeglich hunderte Karteileichen. So landet
       alles auf einem einzigen, und die Zahl stimmt trotzdem. Wer sich
       eintraegt, bekommt seine Ereignisse danach unter der echten Adresse.
       Einzelne Besucher zaehlt Clarity, nicht Klaviyo. */
    var ZAEHLER = 'fq-rad-zaehler';
    /* Das Rad geht NIE unter dem Cookie-Banner auf - zwei Dialoge
       uebereinander kann niemand bedienen, und die Einblendung waere
       verbrannt (danach greift die 7-Tage-Sperre). Es wartet, bis der
       Banner den Radbereich freigibt: entweder weil er weg ist, oder weil
       er woanders sitzt (etwa als Leiste unten). Die Zahl ist nur eine
       Notbremse gegen ewig laufende Timer - 600 halbe Sekunden = 5 Minuten;
       wer so lange nicht entscheidet, bekommt es in dieser Sitzung nicht. */
    var BANNER_WARTE = 600;

    var SPEICHER   = 'fq_willkommensrabatt'; /* wird von klaviyo-auto-discount gelesen */
    var FORM_CACHE = 'fq_klaviyo_formulare';
    var ZU         = 'fq_rad_zu';
    var FERTIG     = 'fq_rad_fertig';
    var STUMM      = 'fq_rad_stumm';

    /* ---- Den alten Formular-Pfad stilllegen ----
       `klaviyo-auto-discount.liquid` haengt selbst am `klaviyoForms`-Ereignis
       und holt sich dort einen Gutschein aus der Formulardefinition. Wuerde
       irgendwo ein Klaviyo-Formular abgeschickt, setzte es per
       `/discount/...` dessen Code - und ueberschriebe damit unseren Gewinn
       im Checkout. Die Datei liest ihre Formularliste aus sessionStorage,
       bevor sie das Netz fragt: wir legen dort eine LEERE Liste ab. Sie
       findet dann keinen Gutschein und steigt selbst aus
       (`if (FORMULARE) return;`). Funktioniert, weil dieses Snippet in
       `layout/theme.liquid` VOR `klaviyo-auto-discount` gerendert wird. */
    try { sessionStorage.setItem(FORM_CACHE, '{}'); } catch (f) {}

    var wurzel = document.getElementById('fqrad');
    if (!wurzel) { return; }

    /* ---- Speicher-Helfer ---- */
    function lies(schluessel) {
      try { var r = localStorage.getItem(schluessel); return r ? JSON.parse(r) : null; }
      catch (f) { return null; }
    }
    function schreib(schluessel, wert) {
      try { localStorage.setItem(schluessel, JSON.stringify(wert)); } catch (f) {}
    }
    function gewinnVon(code) {
      for (var i = 0; i < GEWINNE.length; i++) { if (GEWINNE[i].code === code) { return GEWINNE[i]; } }
      return null;
    }
    function euro(n) { return '€' + n.toFixed(2).replace('.', ','); }

    /* ---- Pruef- und Analyse-Schalter ----
       ?rad=test      Popup sofort, nichts wird gemerkt
       ?rad=NAPFRAD   Gewinn von Hand setzen (auch RAD5 / RAD10)
       ?rad=reset     alles loeschen
       ?rad=stumm|an  Popup fuer diesen Browser still - fuer eine saubere
                      Clarity-Aufzeichnung ohne Popup im Bild. Clarity bietet
                      keine API, um ein Element von der Aufzeichnung
                      auszunehmen, nur Maskieren.
       Der Anhang wird sofort aus der Adresse entfernt, damit die Aufzeichnung
       unter der normalen Produkt-URL landet. */
    var wunsch = null;
    try { wunsch = new URLSearchParams(location.search).get('rad'); } catch (f) {}
    if (wunsch) {
      try {
        var url = new URL(location.href);
        url.searchParams.delete('rad');
        history.replaceState(null, '', url.pathname + (url.search || '') + url.hash);
      } catch (f) {}
    }
    var testModus = wunsch === 'test';

    if (wunsch === 'stumm' || wunsch === 'an') {
      try {
        if (wunsch === 'stumm') { localStorage.setItem(STUMM, '1'); }
        else { localStorage.removeItem(STUMM); }
      } catch (f) {}
    }
    var stumm = false;
    try { stumm = localStorage.getItem(STUMM) === '1'; } catch (f) {}
    /* Aufzeichnung in Clarity wiederfinden: Filter "Custom tag" popup = aus */
    if (stumm) { try { if (window.clarity) { window.clarity('set', 'popup', 'aus'); } } catch (f) {} }

    if (wunsch === 'reset' || testModus) {
      [SPEICHER, ZU, FERTIG].forEach(function (k) {
        try { localStorage.removeItem(k); } catch (f) {}
      });
      document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      try {
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin', body: JSON.stringify({ discount: '' })
        }).catch(function () {});
      } catch (f) {}
    }

    /* Knoten ganz aushaengen, damit Clarity das Popup gar nicht erst sieht. */
    if (stumm && wurzel.parentNode) { wurzel.parentNode.removeChild(wurzel); }

    var kasten   = wurzel.querySelector('.fqrad__box');
    var scheibe  = wurzel.querySelector('.fqrad__scheibe');
    var ctx      = scheibe.getContext('2d');
    var kLeinwand = wurzel.querySelector('.fqrad__konfetti');
    var kctx      = kLeinwand ? kLeinwand.getContext('2d') : null;
    var feld     = wurzel.querySelector('.fqrad__feld');
    var fehler   = wurzel.querySelector('.fqrad__fehler');
    var uhrEl    = wurzel.querySelector('.fqrad__uhr');
    var preisBild  = wurzel.querySelector('.fqrad__preis-bild');
    var preisTitel = wurzel.querySelector('.fqrad__preis-titel');
    var preisSub   = wurzel.querySelector('.fqrad__preis-sub');

    function knopf(name) { return wurzel.querySelector('[data-fqrad="' + name + '"]'); }

    /* ---- Soll das Popup ueberhaupt auf? ---- */
    function verboteneSeite() {
      var p = location.pathname;
      return p.indexOf('/cart') === 0 || p.indexOf('/checkout') === 0 || p.indexOf('/account') === 0;
    }
    function darfAufgehen() {
      var grund = sperrGrund();
      /* Editor und stillgelegte Browser sind wir selbst - die wuerden die
         Zahlen nur verwaessern. */
      if (grund && grund !== 'editor' && grund !== 'stumm') { clarityGesperrt(grund); }
      return !grund;
    }

    /* Leer heisst: das Popup darf auf. Sonst steht hier der Grund, und der
       wandert als Clarity-Tag mit - sonst wuesste man nur, DASS nichts kam,
       nicht warum (Ruhefrist, schon gedreht, ausgenommene Seite). */
    function sperrGrund() {
      if (verboteneSeite()) { return 'seite'; }
      if (window.Shopify && window.Shopify.designMode) { return 'editor'; }
      if (testModus) { return ''; }
      if (stumm) { return 'stumm'; }
      var rabatt = lies(SPEICHER);
      if (rabatt && rabatt.bis && Date.now() < rabatt.bis) { return 'rabatt_laeuft'; }
      if (lies(FERTIG)) { return 'schon_gedreht'; }
      var zu = lies(ZU);
      if (zu && zu.bis && Date.now() < zu.bis) { return 'ruhefrist'; }
      return '';
    }

    /* ================= Das Rad ================= */
    var SEG = (Math.PI * 2) / FELDER.length;

    /* Feld 0 liegt mittig unter dem Zeiger (12 Uhr), die weiteren im
       Uhrzeigersinn. Im Canvas ist 0 rad die 3-Uhr-Richtung, darum -PI/2. */
    function startWinkel(i) { return (-Math.PI / 2) - (SEG / 2) + (i * SEG); }

    /* ---- Bilder ----
       Wird ein Bild nachgeladen, muss das Rad einmal neu gezeichnet werden -
       sonst bliebe das Feld leer, bis etwas anderes ein Neuzeichnen ausloest.
       `crossOrigin` ist noetig, weil die Bilder vom Shopify-CDN kommen. */
    var BILDER = {};
    (function () {
      for (var i = 0; i < GEWINNE.length; i++) {
        var g = GEWINNE[i];
        if (!g.bildUrl) { continue; }
        var bild = new Image();
        bild.crossOrigin = 'anonymous';
        bild.onload = function () { zeichne(); };
        bild.src = g.bildUrl;
        BILDER[g.code] = bild;
      }
    })();
    function bildBereit(code) {
      var b = BILDER[code];
      return !!(b && b.complete && b.naturalWidth);
    }

    function zeichne() {
      var kante = scheibe.getBoundingClientRect().width;
      if (!kante) { return; }
      var dpr = window.devicePixelRatio || 1;
      scheibe.width  = Math.round(kante * dpr);
      scheibe.height = Math.round(kante * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var m = kante / 2;
      var r = m - 6;                          /* Platz fuer den Goldring */
      ctx.clearRect(0, 0, kante, kante);

      /* Helle Felder in zwei Sandtoenen: freigestellte Produktbilder
         brauchen einen hellen Grund, auf Dunkelblau saehen sie wie
         ausgeschnitten aus. Die Abstufung ist dezent, die Trennung
         uebernehmen die goldenen Linien. */
      for (var i = 0; i < FELDER.length; i++) {
        var a0 = startWinkel(i);
        ctx.beginPath();
        ctx.moveTo(m, m);
        ctx.arc(m, m, r, a0, a0 + SEG);
        ctx.closePath();
        ctx.fillStyle = (i % 2 === 0) ? '#ffffff' : '#fdf1e0';
        ctx.fill();
      }

      /* Trennlinien getrennt gezeichnet, damit sie ueber beiden Feldern
         gleich sauber liegen und nicht von der naechsten Fuellung halb
         ueberdeckt werden. */
      ctx.strokeStyle = 'rgba(236, 168, 65, .45)';
      ctx.lineWidth = 1;
      for (i = 0; i < FELDER.length; i++) {
        var a = startWinkel(i);
        ctx.beginPath();
        ctx.moveTo(m, m);
        ctx.lineTo(m + Math.cos(a) * r, m + Math.sin(a) * r);
        ctx.stroke();
      }

      for (i = 0; i < FELDER.length; i++) {
        malSymbol(m, r, startWinkel(i) + SEG / 2, gewinnVon(FELDER[i]));
      }

      /* Goldener Aussenring - fasst das Rad sauber ein. */
      ctx.beginPath();
      ctx.arc(m, m, r + 3, 0, Math.PI * 2);
      ctx.lineWidth = 6;
      ctx.strokeStyle = '#eca841';
      ctx.stroke();
    }

    /* Das Bild steht aufrecht IM Feld: dazu wird so weit gedreht, dass
       "nach aussen" der Bild-Oberkante entspricht (mitte + 90 Grad), dann
       liegt die Feldmitte bei (0, -abstand).

       BEWUSST OHNE WORT IM FELD: bei acht Feldern ist zur Radmitte hin so
       wenig Platz, dass sich "Napfunterlage" und "Gutschein" dort
       ueberlagert haben. Was es zu gewinnen gibt, steht stattdessen als
       Legende unter dem Rad - lesbar in jeder Radstellung. */
    function malSymbol(m, r, mitte, g) {
      if (!g) { return; }

      /* Produktbilder brauchen mehr Flaeche als die Muenzen: sie sind
         freigestellt und matt, die Muenze glaenzt und traegt sich selbst. */
      var groesse = (g.art === 'artikel') ? r * 0.40 : r * 0.34;

      ctx.save();
      ctx.translate(m, m);
      ctx.rotate(mitte + Math.PI / 2);
      ctx.translate(0, -r * 0.62);

      if (bildBereit(g.code)) {
        var b = BILDER[g.code];
        /* Seitenverhaeltnis erhalten - die Napfunterlage ist nicht
           quadratisch und wuerde sonst gestaucht. */
        var f = Math.min(groesse / b.naturalWidth, groesse / b.naturalHeight);
        ctx.drawImage(b, -(b.naturalWidth * f) / 2, -(b.naturalHeight * f) / 2,
                      b.naturalWidth * f, b.naturalHeight * f);
      } else if (g.art === 'artikel') {
        /* Solange das Produktbild laedt, ein ruhiger Platzhalter statt
           eines leeren Feldes. */
        ctx.beginPath();
        ctx.arc(0, 0, groesse * 0.34, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(31, 43, 58, .10)';
        ctx.fill();
      } else {
        malMuenze(groesse, g.betrag);
      }

      ctx.restore();
    }

    /* Goldmuenze mit gepraegtem Betrag. Gezeichnet statt als Datei: bleibt
       auf jedem Bildschirm scharf, und 5 EUR und 10 EUR sind auf einen Blick
       zu unterscheiden - mit demselben Bild waeren sie es nicht. Die
       Praegung wird im selben gedrehten System gezeichnet wie der Text
       darunter, steht also mit ihm auf einer Leserichtung. */
    function malMuenze(groesse, betrag) {
      var rad = groesse * 0.5;

      /* Schatten nach unten, damit die Muenze auf dem Feld aufliegt */
      ctx.save();
      ctx.beginPath();
      ctx.arc(0, rad * 0.16, rad, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(31, 43, 58, .16)';
      ctx.filter = 'blur(3px)';
      ctx.fill();
      ctx.restore();

      /* Koerper: Lichtquelle oben links, darum der versetzte Verlauf */
      var v = ctx.createLinearGradient(-rad, -rad, rad, rad);
      v.addColorStop(0, '#fbe3b4');
      v.addColorStop(0.34, '#eca841');
      v.addColorStop(0.62, '#d9902a');
      v.addColorStop(1, '#f2c377');
      ctx.beginPath();
      ctx.arc(0, 0, rad, 0, Math.PI * 2);
      ctx.fillStyle = v;
      ctx.fill();

      ctx.lineWidth = Math.max(1, rad * 0.08);
      ctx.strokeStyle = '#c07d1c';
      ctx.stroke();

      /* Innenring - gibt der Muenze Tiefe */
      ctx.beginPath();
      ctx.arc(0, 0, rad * 0.78, 0, Math.PI * 2);
      ctx.lineWidth = Math.max(1, rad * 0.05);
      ctx.strokeStyle = 'rgba(255, 249, 236, .55)';
      ctx.stroke();

      /* Glanzbogen oben links */
      ctx.beginPath();
      ctx.arc(0, 0, rad * 0.88, Math.PI * 1.08, Math.PI * 1.52);
      ctx.lineWidth = Math.max(1, rad * 0.12);
      ctx.strokeStyle = 'rgba(255, 255, 255, .5)';
      ctx.lineCap = 'round';
      ctx.stroke();

      /* Praegung */
      var hoch = Math.max(9, Math.round(rad * 0.84));
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.font = '800 ' + hoch + 'px Poppins, Arial, sans-serif';
      ctx.fillStyle = 'rgba(255, 252, 244, .55)';
      ctx.fillText(betrag + '€', 0, rad * 0.05);     /* heller Versatz = Relief */
      ctx.fillStyle = '#7a4c09';
      ctx.fillText(betrag + '€', 0, 0);
    }

    /* Leerlauf: das Rad dreht sich langsam, solange niemand gedreht hat.
       Macht sofort klar, dass es ein Rad ist - und haelt an, sobald es
       losgeht, damit die Ziel-Rechnung nicht durcheinandergeraet. */
    var winkel = 0, leerlauf = null, gedreht = false;
    function leerlaufStart() {
      if (leerlauf || gedreht) { return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      leerlauf = setInterval(function () {
        winkel = (winkel + 0.12) % 360;
        scheibe.style.transform = 'rotate(' + winkel + 'deg)';
      }, 40);
    }
    function leerlaufStop() {
      if (leerlauf) { clearInterval(leerlauf); leerlauf = null; }
    }

    /* ---- Ziehung ----
       Gewichtet nach `chance`. Erst steht der Gewinn fest, dann wird ein
       passendes Feld ausgesucht - nie umgekehrt. */
    function ziehen() {
      var summe = 0, i;
      for (i = 0; i < GEWINNE.length; i++) { summe += GEWINNE[i].chance; }
      var wurf = Math.random() * summe;
      for (i = 0; i < GEWINNE.length; i++) {
        wurf -= GEWINNE[i].chance;
        if (wurf < 0) { return GEWINNE[i]; }
      }
      return GEWINNE[0];
    }
    function feldFuer(code) {
      var passend = [];
      for (var i = 0; i < FELDER.length; i++) { if (FELDER[i] === code) { passend.push(i); } }
      if (!passend.length) { return 0; }
      return passend[Math.floor(Math.random() * passend.length)];
    }

    /* ---- Drehen ----
       Das Feld k liegt unter dem Zeiger, wenn das Rad um -k*SEG gedreht ist.
       Dazu ein paar volle Umdrehungen und ein kleiner Versatz innerhalb des
       Feldes, damit es nicht jedes Mal exakt mittig stehen bleibt. */
    function drehenZu(k, fertig) {
      leerlaufStop();
      gedreht = true;

      /* Feld k steht unter dem Zeiger, wenn das Rad um (360 - k*segGrad)
         gedreht ist. Vom aktuellen Leerlauf-Winkel aus wird die kuerzeste
         Strecke dorthin gesucht und um sechs volle Umdrehungen verlaengert -
         so springt nichts und es sieht nach echtem Schwung aus. */
      var segGrad = 360 / FELDER.length;
      var versatz = (Math.random() - 0.5) * segGrad * 0.6;
      var zielRest = ((360 - k * segGrad + versatz) % 360 + 360) % 360;
      var delta = ((zielRest - (winkel % 360)) % 360 + 360) % 360;
      var gesamt = winkel + delta + 360 * 6;

      var sanft = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var dauer = sanft ? 600 : 4600;

      scheibe.style.transition = 'transform ' + dauer + 'ms cubic-bezier(.16,.74,.16,1)';
      /* Erzwingt, dass der Startwert uebernommen wird, bevor das Ziel kommt. */
      void scheibe.offsetWidth;
      scheibe.style.transform = 'rotate(' + gesamt + 'deg)';
      winkel = gesamt;

      /* `transitionend` feuert nicht zuverlaessig, wenn der Tab im
         Hintergrund liegt - deshalb zusaetzlich eine Uhr. */
      var erledigt = false;
      function einmal() {
        if (erledigt) { return; }
        erledigt = true;
        scheibe.removeEventListener('transitionend', einmal);
        fertig();
      }
      scheibe.addEventListener('transitionend', einmal);
      setTimeout(einmal, dauer + 260);
    }

    /* ================= Konfetti ================= */
    /* Kurzer Schnipsel-Regen beim Gewinn: ein Stoss aus der Mitte der Box,
       danach uebernimmt die Schwerkraft. Laeuft knapp zwei Sekunden und
       blendet aus - laenger wirkt es zaeh, und der Gewinn soll gelesen
       werden, nicht zugedeckt.

       Papier statt Kreisen: die Schnipsel sind Rechtecke, deren Breite mit
       der Drehung schwankt. Das sieht aus, als drehe sich echtes
       Geschenkpapier in der Luft - ein Kreis kann das nicht zeigen. */
    var KONF_DAUER = 1800;
    var KONF_FARBEN = ['#eca841', '#f5bd6d', '#fdf1e0', '#1f2b3a', '#ffffff', '#d9902a'];
    var kLauf = null, kAufraeumen = null;

    function konfettiStop() {
      if (kLauf) { cancelAnimationFrame(kLauf); kLauf = null; }
      if (kAufraeumen) { clearTimeout(kAufraeumen); kAufraeumen = null; }
      if (kLeinwand) { kLeinwand.classList.remove('fqrad--an'); }
      if (kctx && kLeinwand) { kctx.clearRect(0, 0, kLeinwand.width, kLeinwand.height); }
    }

    function konfetti() {
      if (!kLeinwand || !kctx || !kasten) { return; }
      /* Wer Bewegung reduziert haben moechte, bekommt keinen Regen. */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

      var r = kasten.getBoundingClientRect();
      if (!r.width || !r.height) { return; }

      konfettiStop();

      var dpr = window.devicePixelRatio || 1;
      kLeinwand.width  = Math.round(r.width * dpr);
      kLeinwand.height = Math.round(r.height * dpr);
      kctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var teile = [];
      var anzahl = r.width < 520 ? 70 : 110;
      for (var i = 0; i < anzahl; i++) {
        /* Nach oben gerichteter Faecher - von dort faellt alles zurueck */
        var winkel = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.3;
        var wucht  = 5 + Math.random() * 9;
        teile.push({
          x: r.width * (0.5 + (Math.random() - 0.5) * 0.3),
          y: r.height * 0.44,
          vx: Math.cos(winkel) * wucht,
          vy: Math.sin(winkel) * wucht,
          b: 4 + Math.random() * 5,
          h: 7 + Math.random() * 7,
          farbe: KONF_FARBEN[(Math.random() * KONF_FARBEN.length) | 0],
          dreh: Math.random() * Math.PI * 2,
          vdreh: (Math.random() - 0.5) * 0.34
        });
      }

      kLeinwand.classList.add('fqrad--an');
      var start = performance.now(), vorher = start;

      function frame(jetzt) {
        /* Auf 16,7 ms normiert, damit die Schnipsel bei 120 Hz nicht
           doppelt so schnell fallen. Die Obergrenze faengt den Sprung ab,
           wenn der Tab kurz im Hintergrund lag. */
        var dt = Math.min(2.6, (jetzt - vorher) / 16.7);
        vorher = jetzt;

        kctx.clearRect(0, 0, r.width, r.height);
        for (var i = 0; i < teile.length; i++) {
          var t = teile[i];
          t.vy += 0.34 * dt;
          t.vx *= Math.pow(0.99, dt);
          t.x  += t.vx * dt;
          t.y  += t.vy * dt;
          t.dreh += t.vdreh * dt;

          /* Nie ganz auf null, sonst blitzen die Schnipsel weg, statt sich
             sichtbar durch die Kante zu drehen. */
          var breite = t.b * Math.max(0.18, Math.abs(Math.cos(t.dreh * 1.7)));

          kctx.save();
          kctx.translate(t.x, t.y);
          kctx.rotate(t.dreh);
          kctx.fillStyle = t.farbe;
          kctx.fillRect(-breite / 2, -t.h / 2, breite, t.h);
          kctx.restore();
        }

        if (jetzt - start < KONF_DAUER) {
          kLauf = requestAnimationFrame(frame);
        } else {
          kLauf = null;
          kLeinwand.classList.remove('fqrad--an');   /* CSS blendet aus */
          kAufraeumen = setTimeout(function () {
            kctx.clearRect(0, 0, r.width, r.height);
            kAufraeumen = null;
          }, 420);
        }
      }
      kLauf = requestAnimationFrame(frame);
    }

    /* ================= Schritte ================= */
    function zeige(n) {
      var s = wurzel.querySelectorAll('.fqrad__step');
      for (var i = 0; i < s.length; i++) {
        s[i].classList.toggle('fqrad--an', s[i].getAttribute('data-step') === String(n));
      }
    }

    var ticker = null;
    function zwei(n) { return (n < 10 ? '0' : '') + n; }
    function uhrLauf(bis) {
      if (ticker) { clearInterval(ticker); }
      function male() {
        var rest = Math.max(0, bis - Date.now());
        var sek = Math.round(rest / 1000);
        /* Ab einer Stunde mit Stunden anzeigen - bei 24 h stuende sonst "1440:00". */
        var std = Math.floor(sek / 3600);
        var min = Math.floor((sek % 3600) / 60);
        uhrEl.textContent = std > 0
          ? (zwei(std) + ':' + zwei(min) + ':' + zwei(sek % 60))
          : (zwei(min) + ':' + zwei(sek % 60));
        if (rest <= 0 && ticker) { clearInterval(ticker); ticker = null; }
      }
      male();
      ticker = setInterval(male, 1000);
    }

    /* ---- Oeffnen und schliessen ---- */
    var offen = false;
    function auf() {
      if (offen || !darfAufgehen()) { return; }
      offen = true;
      wurzel.hidden = false;
      zeichne();
      leerlaufStart();
      melde('Glücksrad angezeigt');
      try { document.body.style.overflow = 'hidden'; } catch (f) {}
      setTimeout(function () { try { feld.focus({ preventScroll: true }); } catch (f) {} }, 120);
      /* Autofill schlaegt teils erst nach dem Oeffnen zu - zweimal
         nachsehen, sonst bleibt der Knopf grundlos gesperrt. */
      setTimeout(feldGeprueft, 300);
      setTimeout(feldGeprueft, 1200);
    }
    function zu(merken) {
      offen = false;
      wurzel.hidden = true;
      leerlaufStop();
      konfettiStop();
      /* Sonst tickt die Uhr im Hintergrund weiter, bis die 30 Minuten um
         sind - unnoetige Arbeit auf jedem Seitenaufruf danach. */
      if (ticker) { clearInterval(ticker); ticker = null; }
      try { document.body.style.overflow = ''; } catch (f) {}
      /* Kein automatisches Sichern mehr: der Gewinn haengt jetzt an der
         Adresse, und die wird erst im zweiten Schritt abgefragt. Wer ohne
         sie zumacht, hat ihn nicht abgeholt. */
      if (merken && !testModus) { schreib(ZU, { bis: Date.now() + RUHE_TAGE * 86400000 }); }
    }

    /* ---- Messung ----
       Vier Ereignisse an Klaviyo, damit der Trichter sichtbar wird:
       angezeigt -> E-Mail -> Gewinn -> gesichert. Laeuft ueber die
       Onsite-Bibliothek, die auch anonyme Besucher zaehlen kann. Im
       Test-Modus wird nichts gemeldet, damit eigene Durchlaeufe die Zahlen
       nicht verfaelschen. */
    function melde(name, extra) {
      if (testModus) { return; }
      var daten = {
        seite: location.pathname,
        geraet: window.matchMedia('(max-width: 749px)').matches ? 'Handy' : 'Desktop'
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) { daten[k] = extra[k]; }
        }
      }
      klaviyoEreignis(name, daten);
      clarityMelde(name, extra);
    }

    /* ---- Klaviyo: direkt an die Client-API ----
       Frueher lief das ueber `klaviyo.push(['track', ...])`. Das kam kaum
       an: Consentmo blockiert das Onsite-Script bis zur Einwilligung, und
       `track` verwirft ausserdem jeden Besucher, den Klaviyo noch nicht
       kennt. Derselbe Endpunkt wie bei der Anmeldung braucht nichts davon
       und nimmt jedes Ereignis an - dadurch sind die Zahlen ueberhaupt
       erst auswertbar (Cockpit liest sie per Metrik-Aggregat). */
    function klaviyoEreignis(name, daten) {
      var profil = bekannteMail ? { email: bekannteMail } : { anonymous_id: ZAEHLER };
      var koerper = {
        data: {
          type: 'event',
          attributes: {
            properties: daten || {},
            metric:  { data: { type: 'metric',  attributes: { name: name } } },
            profile: { data: { type: 'profile', attributes: profil } }
          }
        }
      };
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(koerper),
          keepalive: true
        }).catch(function () {});
      } catch (f) {}
    }

    /* ---- Zweiter Zaehler: Microsoft Clarity ----
       Klaviyo taugt als Messlatte nicht: Consentmo blockiert das
       Klaviyo-Script, solange niemand die Cookies bestaetigt hat, und
       `track` verwirft ausserdem jeden Besucher, den Klaviyo noch nicht
       kennt. Gemessen am 21.09.: nur rund 5-15 % der Sitzungen kamen an.
       Clarity laedt vor der Einwilligung und sieht jede Sitzung - darum
       liegt die eigentliche Messung ab jetzt dort.

       Zwei Wege, weil das Dashboard sie unterschiedlich zeigt:
         event  -> Zahl unter "Custom events"
         set    -> Filter "Custom tag", um die Aufnahmen zu finden
       Der Schluessel `rad` sammelt alle Stufen einer Sitzung, damit sich
       der Trichter angezeigt -> email -> gedreht -> gesichert direkt im
       Filter nachbauen laesst. */
    var CLARITY_NAMEN = {
      'Glücksrad angezeigt': 'angezeigt',
      'Glücksrad E-Mail':    'email',
      'Glücksrad gedreht':   'gedreht',
      'Glücksrad Gewinn':    'gewinn',
      'Glücksrad gesichert': 'gesichert'
    };

    /* Clarity laedt selbst asynchron. Fehlt die Funktion noch, wird das
       Ereignis ein paar Mal nachgereicht statt weggeworfen - das Popup
       geht erst nach 6 Sekunden auf, dann ist Clarity fast immer da. */
    function anClarity(fn, versuch) {
      versuch = versuch || 0;
      try {
        if (typeof window.clarity === 'function') { fn(window.clarity); return; }
      } catch (f) { return; }
      if (versuch < 10) { setTimeout(function () { anClarity(fn, versuch + 1); }, 1000); }
    }

    function clarityMelde(name, extra) {
      var kurz = CLARITY_NAMEN[name];
      if (!kurz) { return; }
      anClarity(function (c) {
        try {
          c('event', 'rad_' + kurz);
          c('set', 'rad', kurz);
          if (extra && extra.gewinn) { c('set', 'rad_gewinn', extra.gewinn); }
        } catch (f) {}
      });
    }

    /* Auch das Ausbleiben wird getaggt. Erst damit ist die Frage "wie
       vielen wird das Popup gezeigt?" im Dashboard zu beantworten:
       Sitzungen mit rad=angezeigt gegen Sitzungen mit rad=unterdrueckt. */
    function clarityGesperrt(grund) {
      if (testModus) { return; }
      anClarity(function (c) {
        try {
          c('set', 'rad', 'unterdrueckt');
          c('set', 'rad_grund', grund);
        } catch (f) {}
      });
    }

    /* ---- Klaviyo-Popups stilllegen ----
       Nur schwebende Formulare (position: fixed) werden ausgeblendet.
       Eingebettete Formulare, etwa im Footer, bleiben unangetastet - eine
       pauschale CSS-Regel wuerde die mit erwischen. */
    function klaviyoStill(el) {
      var n = el;
      while (n && n !== document.body) {
        var cs;
        try { cs = getComputedStyle(n); } catch (f) { return false; }
        if (cs.position === 'fixed') { n.style.setProperty('display', 'none', 'important'); return true; }
        n = n.parentElement;
      }
      return false;
    }
    function klaviyoAufraeumen() {
      var kandidaten = document.querySelectorAll('[class*="kl-private-reset-css"]');
      for (var i = 0; i < kandidaten.length; i++) {
        var el = kandidaten[i];
        if (!el.offsetHeight) { continue; }
        var cs;
        try { cs = getComputedStyle(el); } catch (f) { continue; }
        if (cs.position === 'fixed') { el.style.setProperty('display', 'none', 'important'); }
      }
    }
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail || e.detail.type !== 'open') { return; }
      var el = document.querySelector('.klaviyo-form-' + e.detail.formId);
      if (!el || !klaviyoStill(el)) { klaviyoAufraeumen(); }
    });
    var kAufraeumen = setInterval(klaviyoAufraeumen, 700);
    setTimeout(function () { clearInterval(kAufraeumen); }, 25000);

    /* ---- Klaviyo: Profil in die Liste ----
       Im Test-Modus wird bewusst nichts gesendet - genau wie bei `melde()`.
       Sonst landen eigene Durchlaeufe als echte Profile in der Liste. */
    /* Ab der Anmeldung laufen die Ereignisse unter der echten Adresse -
       vorher waere es eine Adresse, die nur im Feld stand. */
    var bekannteMail = null;

    function anmelden(mail) {
      if (testModus) { return; }
      bekannteMail = mail;
      var koerper = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                /* Kein `subscriptions`-Block: den lehnt der Client-Endpunkt
                   ab ("not a valid field for the resource profile", 400).
                   Die Einwilligung ergibt sich aus dem Endpunkt selbst. */
                attributes: { email: mail }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: LISTE } } }
        }
      };
      /* Absenden und nicht darauf warten - bei einem Fehlschlag haetten wir
         ohnehin nichts anderes getan, und `keepalive` sorgt dafuer, dass die
         Anfrage auch bei einem Seitenwechsel noch rausgeht. */
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(koerper),
          keepalive: true
        }).catch(function () {});
      } catch (f) {}
      try {
        if (window.klaviyo && window.klaviyo.push) { window.klaviyo.push(['identify', { '$email': mail }]); }
      } catch (f) {}
    }

    /* ---- Gewinn scharf schalten ---- */
    function gutscheinSetzen(g, dann) {
      var bis = Date.now() + MINUTEN * 60000;
      schreib(SPEICHER, { code: g.code, betrag: g.betrag, bis: bis });
      schreib(FERTIG, { bis: bis });
      try {
        fetch('/discount/' + encodeURIComponent(g.code) + '?redirect=/robots.txt',
              { credentials: 'same-origin', keepalive: true })
          .then(function () { if (dann) { dann(); } })
          .catch(function () { if (dann) { dann(); } });
      } catch (f) { if (dann) { dann(); } }
    }

    /* Das andere Snippet beobachtet childList in .fqb-offer - ein kurz
       eingehaengter Knoten laesst es die Rabattzeile sofort neu zeichnen. */
    function buyboxAnstossen() {
      var offer = document.querySelector('.fqb-offer');
      if (!offer) { return; }
      var d = document.createElement('span');
      d.style.display = 'none';
      offer.appendChild(d);
      setTimeout(function () { if (d.parentNode) { d.parentNode.removeChild(d); } }, 30);
    }

    /* ================= Napfunterlage in die Buy Box ================= */
    function napfStil() {
      if (document.getElementById('fqrad-stil')) { return; }
      var s = document.createElement('style');
      s.id = 'fqrad-stil';
      s.textContent =
        '.fqrad-kennzeichen{display:inline-flex;align-items:center;' +
          'margin-right:6px;padding:2px 7px;border-radius:999px;' +
          'background:#1f2b3a;color:#fff;font-size:10.5px;font-weight:800;' +
          'letter-spacing:.02em;text-transform:uppercase;white-space:nowrap;' +
          'vertical-align:middle;}';
      document.head.appendChild(s);
    }

    /* Preise und Kennzeichen. Absichtlich OHNE den Haken, damit diese
       Funktion beliebig oft laufen darf - sie wird bei jeder Aenderung an
       `.fqb-offer` erneut aufgerufen. */
    function napfPreise(g) {
      var karte = document.querySelector('[data-fqb-upsell2]');
      if (!karte) { return false; }

      var jetzt = karte.querySelector('.fqb-upsell__now');
      var statt = karte.querySelector('.fqb-upsell__was');
      /* "gratis" statt "€0,00" - und es rechnet trotzdem richtig:
         `upsell2Preis()` im anderen Snippet schickt den Text durch `zahl()`,
         das bei reinem Text null liefert und dann auf 0 zurueckfaellt. Genau
         das wollen wir - der Warenkorb-Button darf nichts draufrechnen. */
      if (jetzt && jetzt.textContent.trim() !== 'gratis') { jetzt.textContent = 'gratis'; }
      if (statt && statt.textContent.trim() !== euro(g.statt)) { statt.textContent = euro(g.statt); }

      /* Hat die Karte schon eine Pille aus den Section-Einstellungen, wird
         deren Text ersetzt - sonst stehen zwei Pillen uebereinander. */
      var pille = karte.querySelector('.fqb-upsell__badge');
      if (pille) {
        if (pille.textContent.trim() !== g.kennzeichen) { pille.textContent = g.kennzeichen; }
        /* Zusatzklasse statt neuer Pille: die Section liefert die Form,
           wir faerben nur um - so bleibt sie bei Layout-Aenderungen dort
           automatisch richtig. */
        pille.classList.add('fqb-upsell__badge--gewinn');
      } else if (!karte.querySelector('[data-fqrad-kennzeichen]')) {
        var titel = karte.querySelector('.fqb-upsell__title');
        if (titel) {
          napfStil();
          var neu = document.createElement('span');
          neu.setAttribute('data-fqrad-kennzeichen', '');
          neu.className = 'fqrad-kennzeichen';
          neu.textContent = g.kennzeichen;
          titel.insertBefore(neu, titel.firstChild);
        }
      }
      return true;
    }

    /* Der Haken wird GENAU EINMAL je Section-Aufbau gesetzt. Wichtig: nicht
       im Beobachter nachziehen - sonst koennte der Kunde die Napfunterlage
       nicht mehr abwaehlen, weil wir sie sofort wieder anhaken wuerden. */
    function napfAnwenden(g) {
      if (!napfPreise(g)) { return false; }
      var input = document.querySelector('[data-fqb-upsell2-input]');
      if (!input) { return false; }
      if (input.hasAttribute('data-fqrad-gesetzt')) { return true; }
      input.setAttribute('data-fqrad-gesetzt', '');
      if (!input.checked) {
        input.checked = true;
        try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (f) {}
      }
      return true;
    }

    /* Die Zeile in der Summenkachel: klaviyo-auto-discount kennt nur
       Betrags-Gutscheine und schreibt fuer einen unbekannten Code bewusst
       "im Checkout" statt einer erfundenen Zahl. Beim Artikel-Gewinn waere
       das irrefuehrend - es kommt kein Geld mehr ab, die Napfunterlage steht
       schon gratis in der Karte. Also Text tauschen statt Zeile verstecken. */
    function setzen(el, text) {
      if (el && el.textContent.trim() !== text) { el.textContent = text; }
    }
    function aktiverGewinn() {
      var d = lies(SPEICHER);
      if (!d || !d.bis || Date.now() >= d.bis) { return null; }
      return gewinnVon(d.code);
    }
    function zeileUmschreiben() {
      var g = aktiverGewinn();
      if (!g || g.art !== 'artikel' || !g.zeile) { return; }
      var zeile = document.querySelector('[data-fqb-discount-row]');
      if (!zeile) { return; }
      setzen(zeile.querySelector('.fqb-foot-disc__name, .fqb-prow__name'), g.zeile.name);
      setzen(zeile.querySelector('.fqb-foot-disc__sub, .fqb-prow__sub'), g.zeile.sub);
      setzen(zeile.querySelector('.fqb-foot-disc__amt, .fqb-disc-amount'), g.zeile.rechts);
    }

    /* Das andere Snippet baut die Zeile bei jeder Aenderung an `.fqb-offer`
       neu auf. Keine Endlosschleife: es zeichnet nur neu, wenn sich der Code
       aendert - unser Text-Tausch loest dort also nichts aus. */
    function zeileBeobachten() {
      var ziel = document.querySelector('.fqb-offer');
      if (!ziel || ziel.hasAttribute('data-fqrad-beobachtet')) { return; }
      ziel.setAttribute('data-fqrad-beobachtet', '');
      new MutationObserver(function () {
        var g = aktiverGewinn();
        if (g && g.art === 'artikel') { napfPreise(g); }
        zeileUmschreiben();
      }).observe(ziel, { childList: true, subtree: true, characterData: true });
      zeileUmschreiben();
    }

    /* true = nichts mehr zu tun. Fuer 5 EUR und 10 EUR ist sofort Schluss,
       dort macht klaviyo-auto-discount alles allein. */
    function anwenden() {
      var g = aktiverGewinn();
      if (!g) { return true; }
      if (g.art !== 'artikel') { return true; }
      return napfAnwenden(g);
    }
    function anwendenMitWiederholung() {
      var versuche = 0;
      (function probieren() {
        if (anwenden()) { zeileBeobachten(); buyboxAnstossen(); return; }
        if (++versuche > 40) { return; }
        setTimeout(probieren, 250);
      })();
    }

    /* ================= Bedienung ================= */
    function gueltig(wert) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(wert); }

    Array.prototype.forEach.call(wurzel.querySelectorAll('[data-fqrad="zu"]'), function (el) {
      el.addEventListener('click', function () { zu(true); });
    });
    /* Esc schliesst ebenfalls - erwartet man bei einem Dialog. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && offen) { zu(true); }
    });

    /* Der Knopf sagt selbst, woran es liegt: mit Schloss und "E-Mail
       eintragen", solange die Adresse fehlt, danach "Jetzt drehen". */
    /* Der Abhol-Knopf sagt selbst, woran es liegt: mit Schloss und
       "E-Mail eintragen", solange die Adresse fehlt, danach der Aufruf
       zum Abholen. Drehen ist frei - davor steht keine Huerde. */
    function sperre(zu) {
      var b = knopf('abholen');
      if (!b) { return; }
      var t = b.querySelector('[data-fqrad-btntext]');
      b.classList.toggle('fqrad--zu', zu);
      b.setAttribute('aria-disabled', zu ? 'true' : 'false');
      if (t) { t.textContent = zu ? 'E-Mail eintragen' : 'Gewinn abholen'; }
    }
    function gesperrt() { return knopf('abholen').classList.contains('fqrad--zu'); }

    /* Wackeln, Fokus, Hinweis - alles, was ein toter Knopf nicht kann. */
    function zumFeld(text) {
      fehler.textContent = text;
      feld.classList.remove('fqrad--wack');
      void feld.offsetWidth;                 /* Animation neu starten */
      feld.classList.add('fqrad--wack');
      try { feld.focus({ preventScroll: true }); } catch (f) {}
    }
    feld.addEventListener('animationend', function () { feld.classList.remove('fqrad--wack'); });

    function feldGeprueft() {
      feld.classList.remove('fqrad--fehler');
      fehler.textContent = '';
      sperre(!gueltig(feld.value.trim()));
    }
    feld.addEventListener('input', feldGeprueft);
    /* Passwort-Manager und Browser-Autofill setzen den Wert oft ohne
       `input`-Ereignis. Ohne `change` und die Nachkontrolle beim Oeffnen
       bliebe der Knopf gesperrt, obwohl eine Adresse im Feld steht. */
    feld.addEventListener('change', feldGeprueft);
    feld.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { knopf('abholen').click(); }
    });

    knopf('drehen').addEventListener('click', function () {
      var b = knopf('drehen');
      if (b.disabled || b.classList.contains('fqrad--dreht')) { return; }

      b.classList.add('fqrad--dreht');
      b.disabled = true;
      melde('Glücksrad gedreht');

      var gewinn = ziehen();
      letzterGewinn = gewinn;
      drehenZu(feldFuer(gewinn.code), function () {
        gewinnZeigen(gewinn);
      });
    });

    var letzterGewinn = null, gesichert = false;

    function gewinnZeigen(g) {
      letzterGewinn = g;
      preisTitel.textContent = g.lang;
      preisSub.textContent = g.sub;
      if (preisBild) { preisBild.hidden = !g.bild; }

      zeige(2);
      uhrLauf(Date.now() + MINUTEN * 60000);
      /* Erst umschalten, dann der Regen - sonst liegen die Schnipsel kurz
         ueber dem alten Schritt. */
      konfetti();
      /* Zustand des Abhol-Knopfes setzen (Autofill kann schon gefuellt
         haben) und den Blick ins Feld lenken - ohne Tastatur-Sprung. */
      feldGeprueft();
      setTimeout(feldGeprueft, 400);
      melde('Glücksrad Gewinn', { gewinn: g.code });
    }

    /* Der Speicher wird sofort gesetzt, davon lebt die Rabattzeile. Die
       Anfrage an /discount/ darf im Hintergrund nachlaufen - deshalb
       schliesst das Popup ohne Verzoegerung. */
    function sichern() {
      if (!letzterGewinn || gesichert) { return; }
      gesichert = true;
      var g = letzterGewinn;
      gutscheinSetzen(g, function () { buyboxAnstossen(); });
      if (g.art === 'artikel') { anwendenMitWiederholung(); }
      buyboxAnstossen();
      setTimeout(function () { melde('Glücksrad gesichert', { gewinn: g.code }); }, 0);
    }

    knopf('abholen').addEventListener('click', function () {
      var b = knopf('abholen');
      if (b.disabled || b.classList.contains('fqrad--laedt')) { return; }

      var wert = (feld.value || '').trim();
      if (!gueltig(wert)) {
        feld.classList.add('fqrad--fehler');
        zumFeld(wert ? 'Bitte prüf die Adresse – da fehlt noch etwas.'
                     : 'Trag deine E-Mail-Adresse ein, dann ist der Gewinn gesichert.');
        return;
      }

      b.classList.add('fqrad--laedt');
      /* Anmeldung und Gutschein laufen im Hintergrund weiter, das Popup
         schliesst sofort - auf Klaviyos Antwort zu warten waere eine
         spuerbare Pause ohne Gegenwert. */
      anmelden(wert);
      melde('Glücksrad E-Mail');
      sichern();
      zu(false);
    });

    /* ---- Gewinn von Hand setzen (Pruef-Schalter) ---- */
    if (wunsch && gewinnVon(wunsch)) {
      (function (g) {
        gutscheinSetzen(g, function () { buyboxAnstossen(); });
        if (g.art === 'artikel') { anwendenMitWiederholung(); }
      })(gewinnVon(wunsch));
    }

    /* ---- Ein laufender Gewinn wird auch ohne Popup weiter eingetragen ----
       Der Kunde wechselt nach dem Dreh die Seite: die Napfunterlage muss
       dort genauso gratis stehen. */
    anwendenMitWiederholung();
    document.addEventListener('shopify:section:load', anwendenMitWiederholung);

    /* ---- Das Cookie-Banner hat Vorfahrt ----
       Consentmo liegt auf z-index 2147483647, also ueber dem Rad, und sein
       Kasten sitzt mittig genau darauf. Zwei Dialoge uebereinander kann
       niemand bedienen, darum wartet das Rad, bis entschieden ist.
       Der Kasten steckt im Shadow-DOM des Elements <csm-cookie-consent>;
       laesst der sich nicht lesen, wird nicht gewartet - lieber ein Popup
       zu frueh als gar keins. */
    function bannerKasten() {
      try {
        var el = document.querySelector('csm-cookie-consent');
        var sr = el && el.shadowRoot;
        if (!sr) { return null; }
        var kasten = sr.querySelector('.csm-cookie-box');
        if (!kasten) { return null; }
        var r = kasten.getBoundingClientRect();
        return (r.width > 120 && r.height > 60) ? r : null;
      } catch (f) { return null; }
    }

    /* Stoert der Banner wirklich? Entscheidend ist nicht, ob er da ist,
       sondern ob er dort liegt, wo gleich das Rad steht. Der Kasten des
       Rades ist mittig, hoechstens 820 breit und 560 hoch (siehe CSS) -
       messen laesst er sich nicht, solange er `hidden` ist, darum wird die
       Flaeche hier nachgerechnet. Sitzt der Banner als Leiste unten oder in
       einer Ecke, ueberschneidet sich nichts und das Rad geht sofort auf. */
    function bannerStoert() {
      var r = bannerKasten();
      if (!r) { return false; }
      var vb = window.innerWidth, vh = window.innerHeight;
      var bb = Math.min(820, vb - 40), bh = Math.min(vh - 40, 560);
      var links = (vb - bb) / 2, rechts = links + bb;
      var oben  = (vh - bh) / 2, unten  = oben + bh;
      /* 12 px Sicherheitsabstand, damit sie sich nicht beruehren. */
      return !(r.right < links - 12 || r.left > rechts + 12 ||
               r.bottom < oben - 12 || r.top > unten + 12);
    }

    /* Sobald der Banner den Radbereich freigibt, geht es auf - geprueft
       im Halbsekundentakt, also praktisch sofort nach dem Klick. */
    var hatGewartet = false;
    function aufWennFrei(versuch) {
      versuch = versuch || 0;
      /* Der Pruefmodus wartet nicht - sonst dauert jeder Test eine halbe
         Minute, obwohl man das Popup sehen will. */
      if (!testModus && bannerStoert() && versuch < BANNER_WARTE) {
        hatGewartet = true;
        setTimeout(function () { aufWennFrei(versuch + 1); }, 500);
        return;
      }
      if (hatGewartet) {
        anClarity(function (c) { try { c('set', 'rad_banner', 'gewartet'); } catch (f) {} });
      }
      auf();
    }

    /* ---- Ausloeser: 6 Sekunden oder 30 % Scrolltiefe ---- */
    if (darfAufgehen()) {
      var uhrAus = setTimeout(aufWennFrei, testModus ? 500 : SEKUNDEN * 1000);
      var beiScroll = function () {
        var hoehe = document.documentElement.scrollHeight - window.innerHeight;
        if (hoehe > 0 && (window.scrollY / hoehe) >= SCROLL) {
          clearTimeout(uhrAus);
          window.removeEventListener('scroll', beiScroll);
          aufWennFrei();
        }
      };
      window.addEventListener('scroll', beiScroll, { passive: true });
    }

    /* Das Rad haengt an der Breite seines Kastens - nach einer Drehung des
       Geraets muss es neu gezeichnet werden. Der Drehwinkel bleibt, weil er
       am Element und nicht an der Zeichnung haengt. */
    window.addEventListener('resize', function () {
      if (!offen) { return; }
      zeichne();
      /* Das Konfetti-Bild haengt an der alten Boxgroesse - nach einer
         Drehung des Geraets saessen die Schnipsel schief. Lieber sauber
         beenden als verzerrt weiterlaufen. */
      konfettiStop();
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { if (offen) { zeichne(); } });
    }
  })();